import { ArrowLeft, Sparkles, Edit3, CheckCircle, XCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function ReviewResponses() {
  return (
    <HelpArticle
      title="Review Responses"
      description="Understand how suggested responses are created, reviewed, and approved."
    >
      <Step icon={Sparkles} title="AI suggests a response">
        RevUShield uses the review text, business details, and response
        preferences to draft a suggested owner response.
      </Step>

      <Step icon={Edit3} title="You can edit before approval">
        Suggested responses are editable, so you can adjust wording, tone, or
        add business-specific details.
      </Step>

      <Step icon={CheckCircle} title="Approve when ready">
        Approved responses can be posted through the connected Google Business
        Profile workflow.
      </Step>

      <Step icon={XCircle} title="Reject responses you do not want">
        If a response does not fit, reject it and generate or write a better
        one.
      </Step>
    </HelpArticle>
  );
}

function HelpArticle({ title, description, children }) {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <Link
        to="/help"
        className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900"
      >
        <ArrowLeft size={16} />
        Back to Help
      </Link>

      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-6 md:p-8">
        <h1 className="text-3xl font-bold text-slate-900">{title}</h1>
        <p className="text-slate-500 mt-2">{description}</p>

        <div className="mt-8 space-y-4">{children}</div>
      </div>
    </div>
  );
}

function Step({ icon: Icon, title, children }) {
  return (
    <div className="border border-slate-200 rounded-2xl p-5 flex gap-4">
      <div className="h-11 w-11 rounded-xl bg-indigo-100 text-indigo-600 flex items-center justify-center shrink-0">
        <Icon size={21} />
      </div>

      <div>
        <h2 className="font-semibold text-slate-900">{title}</h2>
        <p className="text-sm text-slate-500 mt-1">{children}</p>
      </div>
    </div>
  );
}
